import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { sendPostViewAnalytics } from '../transport';
import { Base64 } from 'js-base64';
import { enrichBannerExtra } from '../utils';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { getLogger } from '@cian/logger/browser';
import { jsx as _jsx } from "react/jsx-runtime";
export function withAdfoxPostViewAnalytics(WrappedComponent, props, analyticsData) {
  var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  var bannerSource = 'adfox';
  var offerType = 'TGB_banner';
  var ComponentWithPostViewAnalytics = function ComponentWithPostViewAnalytics() {
    var parsedDecodedParamsRef = React.useRef({});
    var _useIntersectionObser = useIntersectionObserver({
        onInViewport: function onInViewport(_ref) {
          var _analyticsData$onView;
          var observer = _ref.observer,
            subscribeState = _ref.subscribeState;
          observer.disconnect();
          subscribeState.setSubscribeUnavailable();
          (_analyticsData$onView = analyticsData.onView) === null || _analyticsData$onView === void 0 || _analyticsData$onView.call(analyticsData);
          sendPostViewAnalytics(_objectSpread(_objectSpread({}, analyticsData), {}, {
            bannerSource: bannerSource,
            offerType: offerType
          }), 'show');
        },
        initSubscribeAvailable: false,
        observerOptions: {
          threshold: 0.5
        }
      }),
      elementRef = _useIntersectionObser.elementRef,
      subscribeState = _useIntersectionObser.subscribeState;
    var handleLoad = React.useCallback(function (data) {
      var _props$onLoad;
      var bundleParams = data.bundleParams,
        bundleName = data.bundleName;
      if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
        try {
          var decodedParams = Base64.decode(bundleParams.htmlBase64);
          parsedDecodedParamsRef.current = JSON.parse(decodedParams);
        } catch (e) {
          getLogger().error(e, {
            message: 'Failed to parse decoded params',
            domain: 'postview-analytics-utils#src/components/adfox/adfox.tsx'
          });
          parsedDecodedParamsRef.current = {};
        }
      }

      // Обновить если ID баннера изначально не был указан
      if (analyticsData.banner.id == null) {
        analyticsData.banner.id = Number(data.bundleParams.bannerId);
      }
      analyticsData.banner.extra = enrichBannerExtra(_objectSpread(_objectSpread({}, analyticsData.banner.extra), {}, {
        campaignId: bundleParams.campaignId
      }), parsedDecodedParamsRef.current);
      subscribeState.setSubscribeAvailable();
      sendPostViewAnalytics(_objectSpread(_objectSpread({}, analyticsData), {}, {
        bannerSource: bannerSource,
        offerType: offerType
      }), 'load');
      (_props$onLoad = props.onLoad) === null || _props$onLoad === void 0 || _props$onLoad.call(props, data);
    }, [subscribeState]);
    var handleClick = function handleClick() {
      sendPostViewAnalytics(_objectSpread(_objectSpread({}, analyticsData), {}, {
        bannerSource: bannerSource,
        offerType: offerType
      }), 'click');
    };
    var wrappedComponent = React.useMemo(function () {
      return /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({}, _objectSpread(_objectSpread({}, props), {}, {
        onLoad: handleLoad
      })));
    }, [handleLoad]);
    return /*#__PURE__*/_jsx("div", {
      ref: elementRef,
      style: {
        width: '100%'
      },
      onClick: handleClick,
      children: wrappedComponent
    });
  };
  ComponentWithPostViewAnalytics.displayName = "withPostViewAnalytics(".concat(displayName, ")");
  return ComponentWithPostViewAnalytics;
}